// @flow
import React from 'react'
import './styles.scss'
import { browserCheck } from '@ta-interaktiv/browsercheck'

const isMobile = browserCheck.isMobile

const ConditionalWrapper = ({ condition, wrapper, children }) =>
  condition ? wrapper(children) : children

export class Person extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {}
  }

  setImageSource() {
    let imgSrc = null
    try {
      const trySrc = require('../../images/' + this.props.image)
      imgSrc = trySrc
    } catch (err) {
      console.log('⚠ IMAGE NOT FOUND:', '../../images/' + this.props.image)
      imgSrc = require('../../images/_dummy.jpg')
    }
    return imgSrc
  }

  componentDidMount() {}

  render() {
    return (
      <div
        className={
          isMobile ? 'person five wide column' : 'person three wide column'
        }
      >
        <ConditionalWrapper
          condition={this.props.hasBiography}
          wrapper={children => (
            <a
              href={
                'https://www.' +
                this.props.mediaName +
                '.ch/author/' +
                this.props.unityID
              }
              target='_top'
            >
              {children}
            </a>
          )}
        >
          <div
            className={
              this.props.hasBiography
                ? 'has-more-info image-wrapper ui medium image'
                : 'image-wrapper ui medium image'
            }
          >
            <div className='image-inner'>
              <img
                src={
                  this.props.customImage !== '' &&
                  (this.props.customImage.includes('.jpg') ||
                    this.props.customImage.includes('.jpeg') ||
                    this.props.customImage.includes('.png'))
                    ? 'https://storage.googleapis.com/ta-interaktiv/mitarbeiter-der-redaktion/2022-images/' +
                      this.props.customImage
                    : this.props.unityImage !== ''
                    ? this.props.unityImage
                    : require('../../images/_dummy.jpg')
                }
                style={{
                  transform: `scale(${this.props.scale}) translateY(${this.props.translateY}%)`
                }}
              />
            </div>
          </div>
          {this.props.hasBiography && (
            <div className='tooltip-marker'>
              <div className='marker-wrapper'>
                <i className='small hand pointer outline icon' />
              </div>
            </div>
          )}
          <div className='details'>
            <div className='names'>{this.props.name}</div>
            <div className='function'>{this.props.function}</div>
          </div>
        </ConditionalWrapper>
      </div>
    )
  }
}
